<template>
<v-layout>
  <gat-flex size="xs8">
     <gat-date-edit :label="label" v-model="dateValue" :autofocus="autofocus" @input="updateValue()" :disabled="disabled" :readonly="readonly" :hint="hint" :append-icon="appendIcon"></gat-date-edit>
  </gat-flex>
  <gat-flex size="xs4" class="ml-1">
     <gat-time-edit :label="label2 || 'time'" v-model="timeValue" :autofocus="autofocus" @input="updateValue()" :disabled="disabled" :readonly="readonly" :hint="hint" :append-icon="appendIcon"></gat-time-edit>
  </gat-flex>
</v-layout>
</template>

<script>
  import GatTimeEdit from './GatTimeEdit.vue';
  import GatDateEdit from './GatDateEdit.vue';
  import moment from 'moment';
  import GatFlex from './GatFlex.vue';
  export default {
    name: 'GatDateTimeEdit',
    props: ['value','label','disabled','readonly','hint','autofocus','appendIcon','label2'],
    components: {GatTimeEdit,GatDateEdit,GatFlex},
    data: function() {
      return	{
        dateValue : null,
        timeValue : null,
      }
    },


    created(){
    },

    watch:{
      value(newValue){
        this.dateValue = moment.utc(newValue).toDate();
        this.timeValue = moment.utc(newValue).toDate();
      }
    },

    methods:{

      updateValue() {
        if(this.dateValue != null && this.timeValue != null){
          let datetime = new Date(this.dateValue.getFullYear(),this.dateValue.getMonth(),this.dateValue.getDate(),this.timeValue.getHours(),this.timeValue.getMinutes(),this.timeValue.getSeconds());
          this.$emit('input',datetime);
        }
      }
    },
  }
</script>

<style scoped>

</style>
